import {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import Forms from '../utilities/Forms';
import React, {Component} from 'react';
import {Button, Card, Checkbox, Form, Input, Modal} from 'antd';
import {useDispatch} from "react-redux";
import axios from 'axios'
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {CheckCircleOutlined} from "@ant-design/icons";

function Forgot () {

    const [email, setEmail] = useState('');
    const [validate, setValidate] = useState({});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {error} = Modal;


    const validateforgotPassword = () => {
        let isValid = true;
        let validator = Forms.validator({
            email: {
                value: email,
                isRequired: true,
                isEmail: true
            }
        });
        if (validator !== null) {
            setValidate({
                validate: validator.errors
            })
            isValid = false
        }
        return isValid;
    }

    //email girdikten sonra email gönderme servise
    const resetPasswordDemand = (values) => {
        const {
            email
        } = values;
        console.log(email);
        const validate = validateforgotPassword();
        if (validate) {
            axios("/CreditSystem/ume/resetPasswordDemand", {
                method: 'POST',
                data : {
                    "email" : email
                }
            })
            .then((res) => {
                    console.log(res);
                    if(res && res.data && res.data.code && res.data.code === "0000"){
                        error({
                            title: 'Başarılı',
                            icon: <CheckCircleOutlined />,
                            content: "E-Postanıza gönderilen linkten parolanızı yenileyebilirsiniz!",
                            okText: 'Tamam',
                            onOk() {
                                window.open('/authservice-ui/index.html', "_self");
                            },
                        });
                    } else {
                        error({
                            title: 'Hata',
                            icon: <ExclamationCircleOutlined/>,
                            content: "Lütfen yazdığınız e-posta adresini kontrol ediniz!",
                            okText: 'Tamam',
                        });
                    }
                }
            )
            .catch((err) => {
                console.error(err);
                error({
                    title: 'Hata',
                    icon: <ExclamationCircleOutlined/>,
                    content: "Lütfen yazdığınız e-posta adresini kontrol ediniz!",
                    okText: 'Tamam',
                });
            });
        }
    };

    /*const forgotPassword = (e) => {
        e.preventDefault();
        const validate = validateforgotPassword();

        if (validate) {
            alert('Parola yenileme E-Postası gönderildi ' + email);
            setValidate({});
            setEmail('');
        }

        forgot(e.email).then(r => setLoading(false));
    }*/

    return (
        <div className="form_design">
            <Card title="Parolamı Unuttum">
                <Form form={form} className="auth-form" method="POST" autoComplete={'off'} onFinish={resetPasswordDemand}>

                    <Form.Item
                        name="email"
                        rules={[{required: true, message: 'Lütfen e-posta adresini giriniz.',},
                        ]}>
                        <Input value={email}
                               onChange={(e) => setEmail(e.target.value)}
                               size="large" placeholder="E-Posta"/>
                    </Form.Item>
                    {/*<Form.Item name="email" className="input_border"
                               rules={[{required: true, message: 'E-Posta adresini giriniz'}]}>
                        <Input type="email"
                               className={`form-control ${validate.validate && validate.validate.email ? 'is-invalid ' : ''}`}
                               id="email"
                               name="email"
                               value={email}
                               placeholder="E-Posta"
                               onChange={(e) => setEmail(e.target.value)}
                        />
                        <div
                            className={`invalid-feedback text-start ${(validate.validate && validate.validate.email) ? 'd-block' : 'd-none'}`}>
                            {(validate.validate && validate.validate.email) ? validate.validate.email[0] : ''}
                        </div>
                    </Form.Item>*/}
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block>E-Posta Gönder</Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>


    );
}

export default Forgot;